<template>
  <Modal v-model="visible" @on-ok="ok" @on-cancel="cancel" :loading="modalLoading" 
    closable mask-closable :okText="getTranslation('k023')" :cancelText="getTranslation('b182')" :title="title"
    width="35">
    <Row class="field-line" type="flex">
      <Col flex="1" class="flex-right">{{ getTranslation('b119') }}</Col>
      <Col flex="3" class="flex-left">
      <Select v-model="selMac" class="desc-field" :filterable="true" :transfer="true"
        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
        <Option v-for="item in macList" :value="item.id" :key="item.id">{{ item.code }}</Option>
      </Select></Col>
    </Row>
    <Row class="field-line" type="flex" v-if="downloadMode == 'one'">
      <Col flex="1" class="flex-right">{{ getTranslation('b120') }}</Col>
      <Col flex="3" class="flex-left"><Select class="desc-field" v-model="macSelLib1" :filterable="true"
        :transfer="true" :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
        <Option v-for="item in mac1LibList" :value="item.id" :key="item.id">{{ item.id }}</Option>
      </Select>&nbsp;{{ getTranslation('b121') }}</Col>
    </Row>
    <Row class="field-line" type="flex" v-if="downloadMode == 'batch'">
      <Col flex="2" class="flex-right">{{ getTranslation('p089') }}:</Col>
      <Col flex="3" class="flex-left">&nbsp;{{ getTranslation('b123') }}<Select class="one-field" v-model="selLib1From"
        :filterable="true" :transfer="true" :placeholder="getTranslation('m034')"
        :not-found-text="getTranslation('b038')">
        <Option v-for="item in library" :value="item.program_id" :key="item.program_id">{{ item.program_id }}</Option>
      </Select> </Col>
      <Col flex="1" class="flex-middle">{{ getTranslation('b121') }} → {{ getTranslation('b124') }}</Col>
      <Col flex="3" class="flex-left"><Select class="one-field" v-model="selLib1To" :filterable="true" :transfer="true"
        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
        <Option v-for="item in library" :value="item.program_id" :key="item.program_id">{{ item.program_id }}</Option>
      </Select></Col>
      <Col flex="1" class="flex-left">{{ getTranslation('b121') }}</Col>
    </Row>
    <Row class="field-line" type="flex" v-if="downloadMode == 'batch'">
      <Col flex="2" class="flex-right">{{ getTranslation('b122') }}:</Col>
      <Col flex="3" class="flex-left">&nbsp;{{ getTranslation('b123') }}<Select class="one-field" v-model="selLib2From"
        :filterable="true" :transfer="true" :placeholder="getTranslation('m034')"
        :not-found-text="getTranslation('b038')">
        <Option v-for="item in mac1LibList" :value="item.id" :key="item.id">{{ item.id }}</Option>
      </Select></Col>
      <Col flex="1" class="flex-middle">{{ getTranslation('b121') }} → {{ getTranslation('b124') }}</Col>
      <Col flex="3" class="flex-left"><Select class="one-field" v-model="selLib2To" :filterable="true" :transfer="true"
        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
        <Option v-for="item in mac1LibList" :value="item.id" :key="item.id">{{ item.id }}</Option>
      </Select></Col>
      <Col flex="1" class="flex-left">{{ getTranslation('b121') }}</Col>
    </Row>
  </Modal>
</template>
<script>

import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { Modal, Row, Col, Select, Option } from 'view-design';
import { kindMapLibrary, postJsError } from '@/util/util';

import { mapGetters } from 'vuex'
export default {
  name: 'DownloadLibrary',
  components: {
    Modal, Row, Col, Select, Option
  },
  props: {
    propVisible: Boolean,
    libraryId: Number,
    downloadMode: String,
  },
  data() {
    return {
      modalLoading: true,
      macList: [],
      library: [],
      selMac: -1,
      mac1LibSize: 0,
      macSelLib1: -1,
      selLib1From: -1,
      selLib1To: -1,
      selLib2From: -1,
      selLib2To: -1,
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    title() {
      let title = '';
      if (this.downloadMode == 'batch') {
        title = this.getTranslation('b118')
      } else {
        title = this.getTranslation('b117')
      }
      return title
    },
    visible: {
      get() { return this.propVisible },
      set(val) { this.$emit('input', val) }
    },
    mac1LibList() {
      let rs = [];
      for (var i = 0; i < this.mac1LibSize; i++) {
        rs.push({ "id": i, "ProgramId": i })
      }

      return rs;
    },

  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.init();
      }
    }
  },

  created() {

  },
  methods: {
    init() {
      let url = API_URL["libraryDownloadInit"];
      let params = {
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.macList = res.data.data.macList;
            this.library = res.data.data.library;
            if (this.macList.length > 0) {
              this.selMac = this.macList[0].id
              this.mac1LibSize = kindMapLibrary(this.macList[0].kind)
              this.selLib1From = 0;
              this.selLib1To = 0;
              this.selLib2From = 0;
              this.selLib2To = 0;
              this.$nextTick(() => {
                this.macSelLib1 = 0;
              })
            }
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    ok() {
      this.modalLoading = true;
      let params = {};
      let url = API_URL["libraryDownloadOne"];
      params = {
        machineId: this.selMac,
        fromId: this.libraryId,
        toId: this.macSelLib1,
      };
      if (this.downloadMode == 'batch') {
        url = API_URL["libraryDownloadBatch"];
        params = {
          machineId: this.selMac,
          fromBegin: this.selLib1From,
          fromEnd: this.selLib1To,
          toBegin: this.selLib2From,
          toEnd: this.selLib2To,
        };
      }
      axios.get(url, {
        params: params,
        timeout: 300000,
      })
        .then(res => {
          if (res && res.data && res.data.code && res.data.code == 200) {
            this.visible = false
            this.$Message.success(this.getTranslation('b125'));
          } else if (res && res.data && res.data.code && res.data.msg) {
            this.$Message.error(res.data.msg);
            this.modalLoading = false;
            this.resetModal();
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    cancel() {
    },
    resetModal() {
      this.$nextTick(() => {
        this.modalLoading = true;
      });
    },
  },

}
</script>

<style scoped>
@import url("../../../assets/style/list.css");

.field-line {
  margin-bottom: 8px;
}

.desc-field {
  width: 60%;
}

.one-field {
  width: 85%;
}
</style>